import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { ImpersonationService } from "src/app/_app-core/services/impersonation/impersonation.service";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
    displayName: any;
    impersonate;
    // Quick "Submit Invoice" menu in the header (mirrors the sidebar submenu).
    quickMenuOpen = false;
    canSubmitLogistics: any;
    canSubmitNonPo: any;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router,
        private eRef: ElementRef,
        public imp: ImpersonationService
    ) {}

    toggleQuickMenu(event: MouseEvent) {
        event.stopPropagation();
        this.quickMenuOpen = !this.quickMenuOpen;
    }

    // Close the quick menu when clicking anywhere outside the navbar.
    @HostListener("document:click", ["$event"])
    onDocumentClick(event: MouseEvent) {
        if (
            this.quickMenuOpen &&
            !this.eRef.nativeElement.contains(event.target)
        ) {
            this.quickMenuOpen = false;
        }
    }

    // Collapse/expand the sidebar by toggling the body attribute the theme
    // CSS responds to (body[data-sidebar-size="condensed"]).
    toggleSidebar() {
        const body = document.body;
        const isCondensed =
            body.getAttribute("data-sidebar-size") === "condensed";
        body.setAttribute(
            "data-sidebar-size",
            isCondensed ? "default" : "condensed"
        );
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("eippSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
                localStorage.clear();
                this.router.navigateByUrl("/");
            }
        );
    }

    stopImpersonation() {
        this.router.navigateByUrl("/portal-exit");
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }

        this.canSubmitLogistics = localStorage.getItem("logisticFlag");
        this.canSubmitNonPo = localStorage.getItem("nonPoFlag");
    }
}
